import {observer} from "mobx-react";
import React from "react";
import {useBetween} from "use-between";
import {useModalChat} from "@dropDesk/presentation/pages/chat/ui/modals/visible_modal_search";
import ModalMain from "@dropDesk/presentation/components/modals/modal_main";
import FormInternalChat from "@dropDesk/presentation/pages/chat/ui/internal_chat/form";
import {InternalChatEntity} from "@dropDesk/domain/entities/internal_chat/internal_chat_entity";
import {BackendAction} from "@dropDesk/domain/entities/common/actions_entity";
import ModalInternalChatLinkedUsers from "@dropDesk/presentation/pages/chat/ui/modals/modal_internal_chat_linked_users";
import {InternalChatUserEntity} from "@dropDesk/domain/entities/internal_chat/users/internal_chat_user_entity";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import ModalInformation from "@dropDesk/presentation/components/modals/modal_information";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import ModalInternalChatUpsell from "@dropDesk/presentation/pages/chat/ui/modals/modal_internal_chat_upsell";
import ModalDrawer from "@dropDesk/presentation/components/modals/modal_drawer";
import {InternalChatUsersLists} from "@dropDesk/presentation/pages/chat/ui/internal_chat/list_users";
import ModalDiscardImageEditor from "@dropDesk/presentation/pages/chat/ui/modals/modal_discard_image_editor";

const ModalsChat = observer(
    ({
         loadingInternalChat,
         internalChat,
         onUpdate,
         internalChatUsersDefault,
         onChangeUsersLinked,
         onDeleteUsersLinked,
         onClickAddUser,
         onClickSave,
         onDeleteInternalChat,
         loadingListUsers,
         internalChatUsers,
         hasMoreListUsers,
         loadMoreListUsers,
         onSearchListUsers,
         searchParamUsers,
         onClickEditUsers,
         disposeListUsers,
         onSaveEditUsers,
         isAdmin,
         onActivateInternalChat,
         onDiscardImageEditor,
     }: {
        loadingInternalChat: boolean,
        internalChat?: InternalChatEntity | null
        onUpdate: (internalChat: InternalChatEntity) => void,
        internalChatUsersDefault: InternalChatUserEntity[]
        onChangeUsersLinked: (user: UserEntity) => void,
        onDeleteUsersLinked: (id: string) => void,
        onClickAddUser: () => void
        onClickSave: () => void
        onDeleteInternalChat: () => void

        loadingListUsers: boolean
        internalChatUsers: InternalChatUserEntity[]
        hasMoreListUsers?: boolean
        loadMoreListUsers: () => void
        onSearchListUsers: (value: string) => Promise<void>
        searchParamUsers: string
        onClickEditUsers: () => void
        disposeListUsers: () => void
        onSaveEditUsers?: () => Promise<void>
        isAdmin: boolean
        onActivateInternalChat: () => void
        onDiscardImageEditor: () => void
    }) => {

        const {
            visibleModalNewInternalChat,
            setVisibleModalNewInternalChat,
            visibleModalDeleteInternalChat,
            setVisibleModalDeleteInternalChat,
            visibleModalListInternalChatUsers,
            setVisibleModalListInternalChatUsers,
            visibleModalInternalChatUpsell,
            setVisibleModalInternalChatUpsell,
            visibleModalDiscardImageEditor,
            setVisibleModalDiscardImageEditor,
        } = useBetween(useModalChat);

        return (
            <>
                {visibleModalNewInternalChat && internalChat && <ModalMain
                    open={visibleModalNewInternalChat}
                    ignoreCloseOnClickOutside={true}
                    onRequestClose={() => setVisibleModalNewInternalChat(false)}
                    width={500}
                    renderComponent={
                        <FormInternalChat
                            loading={loadingInternalChat}
                            internalChat={internalChat}
                            onClickSave={onClickSave}
                            onUpdate={onUpdate}
                            onClickAddUser={onClickAddUser}
                            onRemoveChip={(idUser) => onDeleteUsersLinked(idUser)}
                        />
                    }
                />}
                {internalChat && <ModalInternalChatLinkedUsers
                    internalChatUsersEligible={internalChat?.users?.filter((user) => user.action !== BackendAction.delete) ?? []}
                    internalChatUsersDefault={internalChatUsersDefault}
                    internalChat={internalChat}
                    onDeleteUsersLinked={onDeleteUsersLinked}
                    onChangeUsersLinked={onChangeUsersLinked}
                    onSaveEditUsers={onSaveEditUsers}
                />}
                <ModalInformation
                    open={visibleModalDeleteInternalChat}
                    onRequestClose={() => {
                        setVisibleModalDeleteInternalChat(false);
                    }}
                    textHeaderModal={'Excluir Chat Interno'}
                    textButton={'Excluir'}
                    onRequestSave={async () => {
                        onDeleteInternalChat();
                        setVisibleModalDeleteInternalChat(false);
                    }}
                    nameIcon={ICONS_DROPDESK.delete}
                    sizeIcon={130}
                    textInformation={`Deseja realmente excluir este chat interno? Após a exclusão, não será possível recuperar as informações, pois serão apagadas definitivamente.`}
                    loading={loadingInternalChat}
                    isActionDelete={true}
                />

                {visibleModalListInternalChatUsers && <ModalDrawer
                    width={600}
                    visible={visibleModalListInternalChatUsers}
                    onRequestClose={() => setVisibleModalListInternalChatUsers(false)}
                    textHeaderModal={'Fechar'}
                    onRequestSave={() => setVisibleModalListInternalChatUsers(false)}
                    loading={loadingListUsers}
                    renderComponent={() =>
                        <InternalChatUsersLists
                            maxWidthContainer={600}
                            searchParam={searchParamUsers}
                            loading={loadingListUsers}
                            internalChatUsers={internalChatUsers}
                            hasMore={hasMoreListUsers}
                            loadMore={loadMoreListUsers}
                            onSearch={onSearchListUsers}
                            onClickEditUsers={onClickEditUsers}
                            disposeListUsers={disposeListUsers}
                        />}
                />}

                <ModalInternalChatUpsell
                    open={visibleModalInternalChatUpsell}
                    isAdmin={isAdmin}
                    onActivate={onActivateInternalChat}
                    onClose={() => setVisibleModalInternalChatUpsell(false)}
                />

                <ModalDiscardImageEditor
                    open={visibleModalDiscardImageEditor}
                    onCancel={() => setVisibleModalDiscardImageEditor(false)}
                    onDiscard={() => {
                        onDiscardImageEditor();
                        setVisibleModalDiscardImageEditor(false);
                    }}
                />
            </>
        )
    })
export default ModalsChat;
